import { use, type Context } from 'react';

export function createRequiredContextHook<T>(
  context: Context<T>,
  providerName: string,
  hookName: string,
) {
  return function useRequiredContext(): NonNullable<T> {
    const value = use(context);
    if (!value) {
      throw new Error(`${hookName} must be used within a ${providerName}`);
    }

    return value as NonNullable<T>;
  };
}
